import React from 'react'
import Header from '../../Layout/Header'
import Section3 from './Section3'
import Section1 from './Section1'
import Section2 from './Section2'

export default function Dna() {
    return (
        <div className='bg-cover text-white' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='flex flex-col min-h-screen'>
                <div><Header /></div>
                <Section1 />
            </div>
            <Section2 />
            <Section3 />
        </div>
    )
}
